/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Gallery_Desc_SmbInputs */



/**
* | output |
* | --- |
* | "Files from an on-premise network share." |
*
* @param {Spaces_Gallery_Desc_SmbInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_gallery_desc_smb = /** @type {((inputs?: Spaces_Gallery_Desc_SmbInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Gallery_Desc_SmbInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dateien von einer lokalen Netzwerkfreigabe.")
	return /** @type {LocalizedString} */ ("Files from an on-premise network share.")
});